import * as Sentry from "@sentry/react";
import React from "react";
import { LoaderFunctionArgs } from "react-router-dom";

import CompanyMeetings from "./components/CompanyMeetings";

import { SimplifiedQuery, dataLoader } from "../../api/queries/dataLoader";
import { currentUserQuery } from "../../api/queries/defs/auth";
import { meetingsSearchQuery } from "../../api/queries/defs/meetings";
import { MeetingsSearchSortableFields } from "../../api/services/defs/internal-api/meetings";

import { getMeetingsSearchServiceFilters } from "./utils";

import { config } from "./config";

// Data loader function
export const companyMeetingsLoader = ({ params }: LoaderFunctionArgs) => {
	const queries: (() => SimplifiedQuery)[] = [];

	queries.push(() => {
		// Get query state for the page from URL (filters, sort, search, page) using the same logic as useInfoPageTemplateQueryState
		const pageNumber = Number(params?.pageNumber) || config.defaultPageNumber;
		const sort = {
			name: params?.name || config.defaultSortName,
			direction: params?.direction || config.defaultSortDirection,
		};
		const searchValue = params?.search || "";
		const filters = JSON.parse(params?.filters || "{}");
		if (Object.keys(filters).length > 0) {
			// convert all date strings to date objects
			// we can find dates by looking for the string "date-" at the beginning of the value
			for (const key in filters) {
				if (typeof filters[key] === "string" && filters[key].startsWith("date-")) {
					filters[key] = new Date(filters[key].replace("date-", "")) as Date;
				}
			}
		}

		return meetingsSearchQuery({
			limit: config.pageSize,
			skip: (pageNumber - 1) * config.pageSize,
			sort: { name: sort.name as MeetingsSearchSortableFields, direction: sort.direction as "asc" | "desc" },
			...getMeetingsSearchServiceFilters(filters, searchValue),
		});
	});

	return dataLoader([[currentUserQuery], queries]);
};

const CompanyMeetingsPage = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<CompanyMeetings />
		</Sentry.ErrorBoundary>
	);
};

export default CompanyMeetingsPage;
